import React, {createContext, useContext, useEffect, useState} from "react";
import sort, {SortDirection} from "../../../helper/sorter";

const SortContext = createContext(null);

export const useSortContext = () => useContext(SortContext);

export const SortableContainer = ({initialData, initialSortDirection, initialSortColumn, children}) => {
    const [data, setData] = useState(initialData ?? null);
    const [sorting, setSorting] = useState({
        direction: initialSortDirection ?? null,
        column: initialSortColumn ?? null,
        as: null,
    })

    useEffect(
        () => {
            if (sorting.direction !== null && sorting.column !== null && data !== null) {
                const newData = sort(data, sorting.column, sorting.direction, sorting.as === Number);
                setData(newData);
            }
        },
        [sorting]
    )

    useEffect(
        () => {
            setData(initialData)
        },
        [initialData]
    )

    const applySortColumn = (column, as) => {
        if(sorting.column === column) {
            setSorting({
                direction: SortDirection.invert(sorting.direction),
                column: column,
                as: as,
            });
        }
        else {
            setSorting({
                direction: SortDirection.ASC,
                column: column,
                as: as,
            });
        }
    };

    return <SortContext.Provider value={{applySortColumn, data, setData}}>
        {children}
    </SortContext.Provider>;
}

export const SortableHeader = ({column, as, children}) => {
    const { applySortColumn } = useSortContext();
    return <div className={'sortableHeader'} onClick={applySortColumn.bind(null, column, as)}>
        {children}
    </div>
}
